var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSquareBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 37,
    viewBox: "0 0 36 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.8145 24.0062H11.898V11.9938H23.796V24.0062H23.8145ZM17.8655 0C7.99974 0 0 8.06415 0 18.0093C0 27.9545 7.99974 36.0186 17.8655 36.0186C27.7312 36.0186 35.7309 27.9545 35.7309 18.0093C35.7125 8.06415 27.7312 0 17.8655 0Z",
    fill: "#F9B013"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareBox);
export default __webpack_public_path__ + "static/media/square-box.75882287bb5d144a54d5269ac4f584ad.svg";
export { ForwardRef as ReactComponent };